module.exports = __webpack_public_path__ + "static/img/attention.035c55ab.png";